import React, { memo, useMemo } from 'react';
import { cn } from '@/lib/utils';

export interface SplitTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  text: string;
  /** Split by characters (default) or words. */
  split?: 'chars' | 'words';
}

export const SplitText = memo(({ text, split = 'chars', className, ...props }: SplitTextProps) => {
  const parts = useMemo(() => {
    if (split === 'words') {
      return text.split(/(\s+)/g);
    }
    return Array.from(text);
  }, [text, split]);

  return (
    <span className={cn('split-text', className)} {...props}>
      <span className="sr-only">{text}</span>
      <span className="split-text-vis" aria-hidden="true">
        {parts.map((p, i) => {
          const isSpace = p.trim().length === 0;
          if (isSpace) {
            return (
              <span key={`s-${i}`} className="split-text-space">
                {p}
              </span>
            );
          }
          return (
            <span key={`c-${i}`} className="split-text-char">
              {p}
            </span>
          );
        })}
      </span>
    </span>
  );
});

SplitText.displayName = 'SplitText';

